import { atom } from "jotai";
import { IParticipant } from "../types/IParticipant";

export const participantAtom = atom<IParticipant | null>(null);
